import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { CircularProgress } from '@material-ui/core';
import { SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import history from '~/services/history';

import Input from '../../components/Form/Input';
import { useAuth } from '../../hooks/auth';
import { Container } from './styles';

interface ForgotDataInterface {
  [key: string]: string;
}

const ForgotPassword: React.FC = (): JSX.Element => {
  const {
    forgotPassword,
    loading,
    forgotPasswordSuccess,
    resetForgotPasswordSuccess,
  } = useAuth();

  const [triedSendEmail, setTriedSendEmail] = useState(false);

  const handleSubmit: SubmitHandler<ForgotDataInterface> = async (
    data,
  ): Promise<void> => {
    const { email } = data;
    const schema = Yup.object().shape({
      email: Yup.string()
        .email('Insira um email válido')
        .required('Obrigatório. Preencha com seu e-mail de acesso.'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    setTriedSendEmail(true);

    await forgotPassword(email);
  };

  useEffect(() => {
    resetForgotPasswordSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (triedSendEmail && forgotPasswordSuccess) {
      setTriedSendEmail(false);
      history.goBack();
      toast.success('E-mail enviado com sucesso!');
    }
  }, [forgotPasswordSuccess, triedSendEmail]);

  return (
    <Container>
      <Form data-testid="form" onSubmit={handleSubmit}>
        <h1>Esqueceu sua senha ?</h1>
        <p>
          Insira seu e-mail de login que enviaremos as instruções e o link para
          reconfigurar sua senha para seu e-mail de contato cadastrado no Wedo.
        </p>
        <Input
          name="email"
          type="email"
          placeholder="E-mail"
          label="Email de login"
          autoFocus
        />
        <button type="submit">
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
        </button>
        <Link to="/">Voltar para Login</Link>
      </Form>
    </Container>
  );
};
export default ForgotPassword;
